/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsIos
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsIos = FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsIos {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsIos {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsIos | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions);
    }

    return {};
}

